export function getNearestNumber(array: number[], num: number) {
    return array.reduce(function (prev, curr) {
        return Math.abs(curr - num) < Math.abs(prev - num) ? curr : prev
    })
}

export function getNearestLargerNumber(array: number[], num: number) {
    let nearestLarger = null

    for (let i = 0; i < array.length; i++) {
        if (array[i] > num) {
            if (nearestLarger === null || array[i] < nearestLarger) {
                nearestLarger = array[i]
            }
        }
    }

    return nearestLarger
}

export function getPercentageDifference(number1: number, number2: number) {
    const difference = Math.abs(number2 - number1)
    const average = (number1 + number2) / 2
    const percentageDifference = (difference / average) * 100
    return percentageDifference
}
